import DataGrid from "./DataGrid";
import ListInfo from "./ListInfo";
import ExportFiles from "./ExportFiles";
import List from "./List";
import Filter from "./Filter";
import File from "./ExportFiles/exportType";
import PaginationNumbers from "./PaginationNumbers";
import PaginationConfig from "./PaginationConfig";

import PaginationBox from "./PaginationBox";

DataGrid.ListInfo = ListInfo;
DataGrid.ExportFiles = ExportFiles;
DataGrid.List = List;
DataGrid.Filter = Filter;
DataGrid.PaginationBox = PaginationBox;
DataGrid.File = File;
DataGrid.PaginationNumbers = PaginationNumbers;
DataGrid.PaginationConfig = PaginationConfig;

export default DataGrid;
